import auth from './auth.js'



const state = {

}

const actions = {

}

const mutations = {

}

const getters = {

}

const modules = {
    auth
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules
}